<nb-card>
  <nb-card-body>
    <h4 translate="user.policyDialog.title"></h4>
    <div
      class="form-control-group accept-group"
    >
      <p class="subtitle" translate="user.policyDialog.message" [translateParams]="{host: tenant?.name}"></p>

      <div
        class="form-control-group accept-group"
      >
        <nb-checkbox
          [(ngModel)]="privacyAccepted"
          [required]="true"
        >
          <span translate="user.policyDialog.readPrivacy"></span>
          <a [href]="privacyUrl" target="_blank"
          ><strong translate="user.policyDialog.privacyPolicy"></strong
          ></a>
          <span class="required-asterisk">*</span>
        </nb-checkbox>
      </div>

      <nb-checkbox
        name="terms"
        [(ngModel)]="termsAccepted"
        [required]="true"
      >
        <span translate="user.policyDialog.acceptTerms"></span>
        <a [href]="termsUrl" target="_blank"
        ><strong translate="user.policyDialog.termsOfService"></strong
        ></a>
        <span class="required-asterisk">*</span>
      </nb-checkbox>
    </div>


    <button
      nbButton
      status="primary"
      class="margin-top"
      [disabled]="!privacyAccepted || !termsAccepted"
      (click)="acceptPolicy()"
      translate="user.policyDialog.activateButton"
    ></button>

  </nb-card-body>
</nb-card>
